(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405,5664],{

/***/ "./node_modules/@chakra-ui/select/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/form-control/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ "./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Autoplay; }
/* harmony export */ });
const defaultOptions = {
  active: true,
  breakpoints: {},
  delay: 4000,
  jump: false,
  playOnInit: true,
  stopOnInteraction: true,
  stopOnMouseEnter: false,
  stopOnLastSnap: false,
  rootNode: null
};

function Autoplay(userOptions = {}) {
  let options;
  let carousel;
  let interaction;
  let timer = 0;
  let jump = false;
  function init(embla, optionsHandler) {
    carousel = embla;
    const {
      mergeOptions,
      optionsAtMedia
    } = optionsHandler;
    const optionsBase = mergeOptions(defaultOptions, Autoplay.globalOptions);
    const allOptions = mergeOptions(optionsBase, userOptions);
    options = optionsAtMedia(allOptions);
    jump = options.jump;
    interaction = options.stopOnInteraction ? destroy : stop;
    const {
      eventStore
    } = carousel.internalEngine();
    const emblaRoot = carousel.rootNode();
    const root = options.rootNode && options.rootNode(emblaRoot) || emblaRoot;
    carousel.on('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.on('pointerUp', reset);
    if (options.stopOnMouseEnter) {
      eventStore.add(root, 'mouseenter', interaction);
      if (!options.stopOnInteraction) eventStore.add(root, 'mouseleave', reset);
    }
    eventStore.add(document, 'visibilitychange', () => {
      if (document.visibilityState === 'hidden') return stop();
      reset();
    });
    eventStore.add(window, 'pagehide', event => {
      if (event.persisted) stop();
    });
    if (options.playOnInit) play();
  }
  function destroy() {
    carousel.off('pointerDown', interaction);
    if (!options.stopOnInteraction) carousel.off('pointerUp', reset);
    stop();
    timer = 0;
  }
  function play(jumpOverride) {
    stop();
    if (typeof jumpOverride !== 'undefined') jump = jumpOverride;
    timer = window.setTimeout(next, options.delay);
  }
  function stop() {
    if (!timer) return;
    window.clearTimeout(timer);
  }
  function reset() {
    if (!timer) return;
    stop();
    play();
  }
  function next() {
    const {
      index
    } = carousel.internalEngine();
    const kill = options.stopOnLastSnap && index.get() === index.max;
    if (kill) return destroy();
    if (carousel.canScrollNext()) {
      carousel.scrollNext(jump);
    } else {
      carousel.scrollTo(0, jump);
    }
    play();
  }
  const self = {
    name: 'autoplay',
    options: userOptions,
    init,
    destroy,
    play,
    stop,
    reset
  };
  return self;
}
Autoplay.globalOptions = undefined;


//# sourceMappingURL=embla-carousel-autoplay.esm.js.map


/***/ }),

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Findex.tsx&page=%2F!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("./src/pages/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Elements/Carousel/Carousel.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ WikiCarousel; },
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/embla-carousel-react/embla-carousel-react.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/react-icons/md/index.esm.js");
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react-slick/lib/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/slick-carousel/slick/slick.css");
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/slick-carousel/slick/slick-theme.css");
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);











const WikiCarousel = (param)=>{
    let { data , item , options , plugins , Buttons  } = param;
    const [emblaRef, emblaApi] = (0,embla_carousel_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        ...options
    }, plugins);
    const [selectedIndex, setSelectedIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [scrollSnaps, setScrollSnaps] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [prevBtnEnabled, setPrevBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [nextBtnEnabled, setNextBtnEnabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollTo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((index)=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollTo(index);
    }, [
        emblaApi
    ]);
    const onSelect = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        setPrevBtnEnabled(emblaApi.canScrollPrev());
        setNextBtnEnabled(emblaApi.canScrollNext());
    }, [
        emblaApi,
        setSelectedIndex
    ]);
    const scrollPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!emblaApi) return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
    }, [
        emblaApi,
        setScrollSnaps,
        onSelect
    ]);
    const PrevButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--prev",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowBackIos */ .oTp
            })
        });
    };
    const NextButton = (props)=>{
        const { enabled , onClick  } = props;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .zx, {
            className: "embla__button embla__button--next",
            onClick: onClick,
            disabled: !enabled,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                as: react_icons_md__WEBPACK_IMPORTED_MODULE_8__/* .MdOutlineArrowForwardIos */ .Djl
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .chakra.div */ .m$.div, {
                ref: emblaRef,
                overflow: "hidden",
                w: "full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                    w: "full",
                    children: data === null || data === void 0 ? void 0 : data.map((e, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
                            flex: "0 0 auto",
                            minW: "0",
                            maxW: "100%",
                            children: item(e)
                        }, i))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Flex */ .kC, {
                w: "full",
                alignItems: "center",
                gap: "3",
                pt: "4",
                justifyContent: "center",
                children: scrollSnaps.map((_, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_11__/* .RiCheckboxBlankCircleFill */ .o$3,
                        fontSize: "8px",
                        color: index !== selectedIndex ? "brand.200" : "brand.500",
                        cursor: "pointer",
                        onClick: ()=>scrollTo(index)
                    }, index))
            }),
            Buttons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PrevButton, {
                        onClick: scrollPrev,
                        enabled: prevBtnEnabled
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NextButton, {
                        onClick: scrollNext,
                        enabled: nextBtnEnabled
                    })
                ]
            })
        ]
    });
};
const ArrowBtn = (param)=>/*#__PURE__*/ {
    let { ArrowIcon , onClick , top , isNext  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .xu, {
        top: top,
        position: "absolute",
        transform: "translate(0, 150%)",
        display: "grid",
        placeItems: "center",
        onClick: onClick,
        cursor: "pointer",
        borderWidth: "1px",
        borderColor: "carouselArrowBorderColor",
        zIndex: 99,
        bgColor: "carouselArrowBg",
        borderRadius: "50%",
        w: "40px",
        h: "40px",
        right: isNext ? "-20px" : "unset",
        left: isNext ? "unset" : "-20px",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Icon */ .JO, {
            as: ArrowIcon,
            color: "grey"
        })
    });
};
const Carousel = (param)=>/*#__PURE__*/ {
    let { settings , children , topArrow  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...settings,
        nextArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronRight */ .Dli,
            isNext: true
        }),
        prevArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ArrowBtn, {
            top: topArrow,
            ArrowIcon: react_icons_fa__WEBPACK_IMPORTED_MODULE_12__/* .FaChevronLeft */ .bUI
        }),
        children: children
    });
};


/***/ }),

/***/ "./src/components/Elements/EditorRank/EditorRank.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");




const RankIcon = (param)=>{
    let { rank , size  } = param;
    switch(rank){
        case 0:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#DD6B20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 1:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "#D69E2E",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case 2:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "thirdRankColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiTrophyFill */ .e6w, {
                    fontSize: size
                })
            });
        case -1:
            return null;
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5, {
                color: "brandLinkColor",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_3__/* .RiStarFill */ .Kz, {
                    fontSize: size
                })
            });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (RankIcon);


/***/ }),

/***/ "./src/components/Profile/CustomTab.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CustomTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");



const CustomTab = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref)=>{
    const { noTab , p , ...rest } = props;
    const tabProps = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useTab */ .xD)({
        ...rest,
        ref
    });
    const isSelected = !!tabProps["aria-selected"];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .chakra.button */ .m$.button, {
        display: "flex",
        alignItems: "center",
        _focus: {
            boxShadow: "none"
        },
        p: p || "5",
        cursor: "pointer",
        color: "fadedText2",
        pos: "relative",
        ...isSelected && {
            color: "black",
            _dark: {
                color: "white"
            },
            _after: {
                transition: "background-color 0.4s ease 0s",
                bg: "blue.400",
                bottom: 0,
                left: 0,
                content: "''",
                h: "2px",
                w: "full",
                pos: "absolute",
                borderTopRadius: "base"
            }
        },
        ...props,
        ...!noTab && tabProps,
        children: tabProps.children
    });
});


/***/ }),

/***/ "./src/data/AllCategoriesData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AllCategoriesData; }
/* harmony export */ });
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");

const AllCategoriesData = [
    {
        id: "nfts",
        title: "NFTs",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiImage2Fill */ .RXd,
        description: "The NFTs (non-fungible tokens) category covers all things NFT from collections like the Bored Ape Yacht Club to games like Axie Infinity to artists like Beeple.",
        cardImage: "/images/categories/nfts-card.png",
        heroImage: "/images/categories/nfts.png"
    },
    {
        id: "defi",
        title: "Decentralized Finance",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiMoneyCnyCircleFill */ .CDL,
        description: "The Decentralized Finance (DeFi) category covers everything from stablecoin projects like Frax Finance to concepts like Yield Farming to the oracles which power DeFi like Chainlink.",
        cardImage: "/images/categories/defi-card.png",
        heroImage: "/images/categories/defi.png"
    },
    {
        id: "exchanges",
        title: "Exchanges",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiExchangeBoxFill */ .zZv,
        description: "The Exchanges category covers all crypto exchanges including both centralized exchanges like Binance or Coinbase and decentralized exchanges like Uniswap or Quickswap.",
        cardImage: "/images/categories/exchanges-card.png",
        heroImage: "/images/categories/exchanges.png"
    },
    {
        id: "cryptocurrencies",
        title: "Cryptocurrencies",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiBitCoinFill */ .KCp,
        description: "This cryptocurrencies category covers all cryptocurrencies from Bitcoin to IQ. ",
        cardImage: "/images/categories/cryptocurrencies-card.png",
        heroImage: "/images/categories/cryptocurrencies.jpg"
    },
    {
        id: "daos",
        title: "DAOs",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiTeamFill */ .Qeh,
        description: "The DAOs category covers decentralized autonomous organizations of all kinds from DeFi DAOs like Olympus DAO to knowledge focused DAOs like BrainDAO.",
        cardImage: "/images/categories/daos-card.png",
        heroImage: "/images/categories/daos.png"
    },
    {
        id: "people",
        title: "People in crypto",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiUser3Fill */ .IIZ,
        description: "The People in Crypto category covers everyone working to grow the crypto space from developers to artists to marketers to policy makers and everyone in between.",
        cardImage: "/images/categories/people-card.png",
        heroImage: "/images/categories/people.png"
    },
    {
        id: "dapps",
        title: "Decentralized Applications",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiCopperDiamondLine */ .qGc,
        description: "The Decentralized Application (dapps) category covers everything from time-weighted average market maker (TWAMM) like Fraxswap to DeFi lending protocols like Aave.",
        cardImage: "/images/categories/dapps-card.png",
        heroImage: "/images/categories/dapps.jpg"
    },
    {
        id: "organizations",
        title: "Organizations",
        icon: react_icons_ri__WEBPACK_IMPORTED_MODULE_0__/* .RiOrganizationChart */ .W7I,
        description: "The Organizatons category covers companies and other organizations that develop, implement, or utilize blockchain technology.",
        cardImage: "/images/categories/organizations-card.png",
        heroImage: "/images/categories/organizations.jpg"
    }
];


/***/ }),

/***/ "./src/pages/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/select/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__("./node_modules/next/router.js");
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/textUtils.ts
var textUtils = __webpack_require__("./src/utils/textUtils.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 6 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var system_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/skeleton/dist/index.esm.js");
;// CONCATENATED MODULE: ./src/components/Landing/LoadingFeaturedWikiCard.tsx



const TrendingSkeleton = ()=>{
    const itemsCount = [
        1,
        2,
        3,
        4
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
        w: "full",
        pt: {
            base: "2",
            lg: "4"
        },
        px: "2",
        gap: "5",
        overflow: "hidden",
        children: itemsCount.map((_item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                w: "full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        minW: "2",
                        alignSelf: "center",
                        children: i + 1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                        rounded: "lg",
                        w: {
                            base: "55px",
                            md: "65px",
                            lg: "75px"
                        },
                        h: {
                            base: "48px",
                            md: "55px",
                            lg: "63px"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                        w: "full",
                        alignItems: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "16px",
                                w: "100px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "14px",
                                w: "280px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                rounded: "lg",
                                h: "14px",
                                w: "180px"
                            })
                        ]
                    })
                ]
            }))
    });
};
const LoadingFeaturedWikiCard = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
        px: 2,
        mx: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            alignSelf: "center",
            direction: "column",
            textAlign: "left",
            bg: "white",
            _dark: {
                bgColor: "gray.700",
                color: "white"
            },
            cursor: "pointer",
            rounded: "lg",
            shadow: "md",
            gap: "2",
            pb: "3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                    w: "full",
                    height: "250px",
                    rounded: "md"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    direction: "column",
                    px: "5",
                    gap: "2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "16px",
                            w: "100px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "14px",
                            w: "280px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                            rounded: "lg",
                            h: "14px",
                            w: "180px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                    alignItems: "center",
                                    gap: 3,
                                    width: "50%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* SkeletonCircle */.s7, {
                                            size: "30px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                            rounded: "lg",
                                            h: "18px",
                                            w: "60px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                    rounded: "lg",
                                    h: "18px",
                                    w: "100px"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/TrendingCard.tsx











const TrendingCard = (param)=>{
    let { wikis =[] , title , icon , isTrending  } = param;
    const [wikiData, setWikiData] = react.useState(isTrending ? wikis.todayTrending : wikis);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        py: "1",
        maxW: {
            base: "min(90vw, 400px)",
            md: "96",
            lg: "392"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            w: "full",
            rounded: "lg",
            shadow: "lg",
            minH: "500px",
            py: 5,
            bg: "white",
            _dark: {
                bgColor: "gray.700",
                color: "white"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    w: "full",
                    alignItems: "center",
                    pl: "2",
                    mb: "2",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                    cursor: "pointer",
                                    fontSize: "2xl",
                                    fontWeight: 600,
                                    color: "brandLinkColor",
                                    as: icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: {
                                        base: "md",
                                        lg: "18px"
                                    },
                                    pl: 2,
                                    fontWeight: "600",
                                    children: title
                                })
                            ]
                        }),
                        isTrending && /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_dist_index_esm/* Select */.Ph, {
                            h: "30px",
                            fontSize: "12px",
                            w: "120px",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ChevronDownIcon */.v4, {}),
                            mr: "2",
                            borderColor: "rankingListBorder",
                            onChange: (e)=>{
                                setWikiData(wikis[e.target.value]);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "todayTrending",
                                    children: "Today"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "weekTrending",
                                    children: "Last Week"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: "monthTrending",
                                    children: "Last Month"
                                })
                            ]
                        })
                    ]
                }),
                wikis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                    w: "full",
                    pt: "2",
                    px: "2",
                    gap: "2",
                    overflow: "hidden",
                    children: wikiData === null || wikiData === void 0 ? void 0 : wikiData.map((wiki, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                            w: "full",
                            px: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                                        href: "/wiki/".concat(wiki.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                                            ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                            w: {
                                                base: "50px",
                                                md: "60px",
                                                lg: "70px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                                src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                                                alt: wiki.title,
                                                borderRadius: "md",
                                                overflow: "hidden",
                                                imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                                imgH: Constants/* IMAGE_BOX_SIZE */.xh
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        direction: "column",
                                        justifyContent: "flex-start",
                                        textAlign: "start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                fontWeight: "thin",
                                                cursor: "pointer",
                                                color: "black",
                                                _dark: {
                                                    color: "white"
                                                },
                                                fontSize: "18px",
                                                overflow: "hidden",
                                                onClick: ()=>router_default().push("wiki/".concat(wiki.id)),
                                                children: (0,textUtils/* shortenText */.El)(wiki.title, 24)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                                display: {
                                                    base: "none",
                                                    md: "-webkit-box"
                                                },
                                                noOfLines: 2,
                                                w: "97%",
                                                textOverflow: "ellipsis",
                                                overflow: "hidden",
                                                fontSize: "12px",
                                                fontWeight: "thin",
                                                children: wiki.summary
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, i))
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TrendingSkeleton, {})
            ]
        })
    });
};
/* harmony default export */ var Landing_TrendingCard = (TrendingCard);

// EXTERNAL MODULE: ./src/hooks/useENSData.ts
var useENSData = __webpack_require__("./src/hooks/useENSData.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getFormattedDate.ts
var getFormattedDate = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkOverlay.tsx
var LinkOverlay = __webpack_require__("./src/components/Elements/LinkElements/LinkOverlay.tsx");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/Link.tsx
var Link = __webpack_require__("./src/components/Elements/LinkElements/Link.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/FeaturedWikiCard.tsx













const FeaturedWikiCard = (param)=>{
    let { wiki  } = param;
    var ref, ref1, ref2;
    const [, ensName] = (0,useENSData/* useENSData */.L)(wiki.user.id);
    const getLatestEdited = ()=>{
        let lastEditedTime = null;
        if (wiki.updated) {
            lastEditedTime = (0,getFormattedDate/* getReadableDate */._)(wiki.updated);
        } else if (wiki.created) {
            lastEditedTime = (0,getFormattedDate/* getReadableDate */._)(wiki.created);
        }
        return lastEditedTime;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        flex: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
            px: 2,
            mx: "auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                alignSelf: "center",
                direction: "column",
                textAlign: "left",
                bg: "white",
                color: "black",
                _dark: {
                    bgColor: "gray.700",
                    color: "white"
                },
                cursor: "pointer",
                rounded: "lg",
                shadow: "md",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AspectRatio */.oM, {
                        ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                        h: {
                            base: "250px",
                            md: "250px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                            src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wiki.images),
                            alt: wiki.title,
                            borderTopRadius: "md",
                            overflow: "hidden",
                            objectFit: "cover",
                            imgW: Constants/* IMAGE_BOX_SIZE */.xh * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                            imgH: Constants/* IMAGE_BOX_SIZE */.xh
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        direction: "column",
                        justify: "space-between",
                        fontWeight: "semibold",
                        p: 4,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkOverlay/* default */.Z, {
                                href: "/wiki/".concat(wiki === null || wiki === void 0 ? void 0 : wiki.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                    width: "90%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    fontSize: {
                                        base: "14px",
                                        md: "18px"
                                    },
                                    children: wiki === null || wiki === void 0 ? void 0 : wiki.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "12px",
                                maxW: "90%",
                                minH: 12,
                                color: "homeDescriptionColor",
                                my: 2,
                                children: wiki && (0,getWikiSummary/* getWikiSummary */.L)(wiki, getWikiSummary/* WikiSummarySize.Small */.D.Small)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                        alignItems: "center",
                                        gap: 3,
                                        width: "50%",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/account/".concat(wiki === null || wiki === void 0 ? void 0 : (ref = wiki.user) === null || ref === void 0 ? void 0 : ref.id),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                                                    alt: (0,getUsername/* getUsername */.M)(wiki === null || wiki === void 0 ? void 0 : wiki.user, ensName),
                                                    size: 20,
                                                    address: wiki === null || wiki === void 0 ? void 0 : wiki.user.id,
                                                    avatarIPFS: (ref1 = wiki === null || wiki === void 0 ? void 0 : wiki.user.profile) === null || ref1 === void 0 ? void 0 : ref1.avatar
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "/account/".concat(wiki === null || wiki === void 0 ? void 0 : (ref2 = wiki.user) === null || ref2 === void 0 ? void 0 : ref2.id),
                                                color: "brand.500 !important",
                                                fontSize: "sm",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                children: (0,getUsername/* getUsername */.M)(wiki === null || wiki === void 0 ? void 0 : wiki.user, ensName)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                        width: "50%",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        color: "gray.400",
                                        _dark: {
                                            color: "whiteAlpha.900"
                                        },
                                        fontWeight: "400",
                                        fontSize: "sm",
                                        textAlign: "right",
                                        children: [
                                            "Last Edited ",
                                            getLatestEdited()
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js
var embla_carousel_autoplay_esm = __webpack_require__("./node_modules/embla-carousel-autoplay/embla-carousel-autoplay.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/Carousel/Carousel.tsx
var Carousel = __webpack_require__("./src/components/Elements/Carousel/Carousel.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/FeaturedWikis.tsx








const FeaturedWikis = (param)=>{
    let { featuredWikis  } = param;
    const OPTIONS = {
        loop: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
        pt: "1",
        minH: "500px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            maxW: {
                base: "min(90vw, 400px)",
                md: "96",
                lg: "392"
            },
            w: "full",
            shadow: "lg",
            rounded: "lg",
            py: 3,
            bg: "white",
            _dark: {
                bgColor: "gray.700",
                color: "white"
            },
            color: "black",
            textAlign: "center",
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(system_dist_index_esm/* chakra.div */.m$.div, {
                    w: "full",
                    alignItems: "center",
                    display: "flex",
                    pl: "2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            cursor: "pointer",
                            color: "brandLinkColor",
                            fontSize: "2xl",
                            fontWeight: 600,
                            as: ri_index_esm/* RiStarFill */.Kz
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                            fontSize: {
                                base: "md",
                                lg: "18px"
                            },
                            pl: 2,
                            fontWeight: "600",
                            children: "Featured wikis"
                        })
                    ]
                }),
                featuredWikis ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* WikiCarousel */.B, {
                        data: featuredWikis,
                        item: (wiki)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                px: "3",
                                pt: {
                                    base: "1",
                                    md: "3"
                                },
                                pb: {
                                    base: "6",
                                    md: "3"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedWikiCard, {
                                    wiki: wiki
                                })
                            }, "wiki-".concat(wiki.id)),
                        plugins: [
                            (0,embla_carousel_autoplay_esm/* default */.Z)()
                        ],
                        options: OPTIONS
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingFeaturedWikiCard, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Landing/TrendingWikis.tsx






const TrendingWikis = (param)=>{
    let { trending , recent =[] , featuredWikis =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        mt: 10,
        px: {
            base: 3,
            md: 8
        },
        pb: {
            base: 5,
            md: 20
        },
        pt: 0,
        textAlign: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
            alignItems: "center",
            justifyContent: "center",
            maxW: {
                base: "403px",
                md: "fit-content"
            },
            mx: "auto",
            flexWrap: "wrap",
            gap: 4,
            minH: "500px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingCard, {
                    title: "Trending Wikis",
                    icon: ri_index_esm/* RiBarChartFill */.jwm,
                    wikis: trending,
                    isTrending: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingCard, {
                    title: "Recent Edits",
                    icon: ri_index_esm/* RiTimeFill */.N$g,
                    wikis: recent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedWikis, {
                    featuredWikis: featuredWikis
                })
            ]
        })
    });
};
/* harmony default export */ var Landing_TrendingWikis = (TrendingWikis);

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/data/AllCategoriesData.ts
var AllCategoriesData = __webpack_require__("./src/data/AllCategoriesData.ts");
;// CONCATENATED MODULE: ./src/components/Landing/CategoriesList.tsx









const CATEGORY_IMAGE_BOX_SIZE = 300;
const NUM_OF_CATEGORIES = 6;
const CategoriesList = ()=>{
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    const newCategoryList = [];
    while(newCategoryList.length < NUM_OF_CATEGORIES){
        const randIndex = Math.floor(Math.random() * AllCategoriesData/* AllCategoriesData.length */.V.length);
        const randCategory = AllCategoriesData/* AllCategoriesData */.V[randIndex];
        if (!newCategoryList.includes(randCategory)) {
            newCategoryList.push(randCategory);
        }
        if (randIndex === AllCategoriesData/* AllCategoriesData.length */.V.length - 1 && !newCategoryList.includes(AllCategoriesData/* AllCategoriesData */.V[randIndex])) {
            newCategoryList.push(AllCategoriesData/* AllCategoriesData */.V[randIndex]);
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
        mt: 10,
        mb: 20,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                textAlign: "center",
                fontWeight: "700",
                fontSize: {
                    base: "3xl",
                    lg: 46
                },
                children: "".concat(t("browseCategory"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                color: "homeDescriptionColor",
                fontSize: {
                    base: "lg",
                    lg: 22
                },
                pb: 9,
                px: 4,
                textAlign: "center",
                maxW: "800",
                children: "".concat(t("browseCategoryDescription"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SimpleGrid */.MI, {
                maxW: "1050px",
                w: "100%",
                mx: "auto",
                gridTemplateColumns: {
                    base: "repeat(1, 1fr)",
                    md: "repeat(2, 1fr)",
                    lg: "repeat(3, 1fr)"
                },
                spacingX: 6,
                spacingY: 12,
                px: 6,
                children: newCategoryList.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
                            _hover: {
                                boxShadow: "rgb(4 17 29 / 25%) 0px 0px 8px 0px"
                            },
                            cursor: "pointer",
                            bgColor: "cardBg",
                            borderRadius: "lg",
                            overflow: "hidden",
                            shadow: "base",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkOverlay/* default */.Z, {
                                href: "/categories/".concat(category.id),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                                        bgColor: "DimColor",
                                        src: category.cardImage,
                                        h: "200px",
                                        w: "100%",
                                        alt: category.title,
                                        imgW: CATEGORY_IMAGE_BOX_SIZE * Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
                                        imgH: CATEGORY_IMAGE_BOX_SIZE
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        py: "4",
                                        w: "100%",
                                        textAlign: "center",
                                        fontWeight: "bold",
                                        fontSize: "lg",
                                        size: "md",
                                        children: category.title
                                    })
                                ]
                            })
                        })
                    }, category.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                mt: "10 !important",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                        href: "/categories",
                        h: "50px",
                        w: {
                            base: 32,
                            lg: 40
                        },
                        variant: "outline",
                        bgColor: "btnBgColor",
                        prefetch: false,
                        children: "View More"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Landing_CategoriesList = (CategoriesList);

;// CONCATENATED MODULE: ./src/components/Landing/DiscoverMore.tsx




const DiscoverMore = (param)=>{
    let { tagsData  } = param;
    if (!tagsData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        bgColor: "gray.50",
        _dark: {
            bgColor: "whiteAlpha.50"
        },
        p: 8,
        pb: 20,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
            maxW: "1020px",
            mx: "auto",
            py: 8,
            px: 4,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                    fontWeight: "600",
                    opacity: 0.8,
                    fontSize: 20,
                    children: "Discover More on IQ.wiki"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                    mt: 8,
                    spacing: 4,
                    children: tagsData === null || tagsData === void 0 ? void 0 : tagsData.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* Link */.rU, {
                            as: "li",
                            borderWidth: "1px",
                            px: 4,
                            py: 1,
                            fontSize: 18,
                            rounded: "full",
                            borderColor: "gray.300",
                            color: "gray.600",
                            fontWeight: "500",
                            href: "/tags/".concat(tag.id),
                            sx: {
                                "&:hover, &:focus, &:active": {
                                    bgColor: "gray.100",
                                    textDecoration: "none",
                                    boxShadow: "none",
                                    _dark: {
                                        bgColor: "whiteAlpha.100"
                                    }
                                }
                            },
                            _dark: {
                                color: "whiteAlpha.900",
                                borderColor: "whiteAlpha.700"
                            },
                            children: tag.id
                        }, tag.id))
                })
            ]
        })
    });
};
/* harmony default export */ var Landing_DiscoverMore = (DiscoverMore);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/media-query/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tabs/dist/index.esm.js
var tabs_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tabs/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/humanize-plus/dist/humanize.js
var humanize = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
// EXTERNAL MODULE: ./src/components/Profile/CustomTab.tsx
var CustomTab = __webpack_require__("./src/components/Profile/CustomTab.tsx");
// EXTERNAL MODULE: ./src/components/Elements/EditorRank/EditorRank.tsx
var EditorRank = __webpack_require__("./src/components/Elements/EditorRank/EditorRank.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/Leaderboard.tsx










const SECTIONS = [
    {
        period: "Day",
        disabled: true
    },
    {
        period: "Month",
        disabled: true
    },
    {
        period: "Year",
        disabled: true
    },
    {
        period: "All time",
        disabled: false
    }
];
const LeaderBoardCard = (param)=>{
    let { editor , index  } = param;
    const [, ensUserName] = (0,useENSData/* useENSData */.L)(editor.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* LinkBox */.fG, {
        flex: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.div */.m$.div, {
            p: 2,
            mx: "auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                alignSelf: "center",
                direction: "column",
                textAlign: "left",
                maxW: {
                    base: "min(90vw, 400px)",
                    md: "96",
                    lg: "388"
                },
                cursor: "pointer",
                mx: "auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkOverlay/* default */.Z, {
                    href: "/account/".concat(editor.id),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                            alt: "user",
                            overflow: "hidden",
                            borderWidth: 2,
                            borderColor: "white",
                            rounded: "full",
                            justifySelf: "center",
                            size: 130,
                            address: editor.id,
                            wrapperProps: {
                                zIndex: "calc(var(--chakra-zIndices-sticky) - 1)"
                            },
                            svgProps: {
                                boxSize: "32",
                                overflow: "hidden",
                                borderWidth: 2,
                                borderColor: "white",
                                rounded: "full",
                                justifySelf: "center"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                            my: "6",
                            children: [
                                ensUserName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: "md",
                                    textAlign: "center",
                                    color: "brandLinkColor",
                                    children: ensUserName
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        height: "14px",
                                        rounded: "lg",
                                        w: "130px"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                    fontSize: "sm",
                                    textAlign: "center",
                                    children: [
                                        humanize.intComma(editor.totalRewards),
                                        " IQ Earned"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EditorRank/* default */.Z, {
                            size: "30",
                            rank: index
                        })
                    ]
                })
            })
        })
    });
};
const LeaderBoard = (param)=>{
    let { leaderboards  } = param;
    const tabPadding = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: "3",
        md: "5"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        px: {
            base: 3,
            md: 8
        },
        py: {
            base: 5,
            md: 20
        },
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                textAlign: "center",
                mb: 4,
                fontWeight: "700",
                fontSize: {
                    base: "3xl",
                    lg: 46
                },
                children: "Leaderboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                color: "homeDescriptionColor",
                fontSize: {
                    base: "lg",
                    lg: 22
                },
                mx: "auto",
                mb: 9,
                px: 4,
                children: "An Highlight of exceptional editors who has contributed greatly to the IQ wiki."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                maxW: "1160px",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* Tabs */.mQ, {
                        defaultIndex: 3,
                        alignSelf: "self-start",
                        w: "full",
                        my: "6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabList */.td, {
                            pl: 5,
                            border: "none",
                            children: SECTIONS.map((section, sid)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomTab/* CustomTab */.o, {
                                    _selected: {
                                        color: "brandLinkColor !important",
                                        _after: {
                                            background: "brandLinkColor !important"
                                        }
                                    },
                                    _disabled: {
                                        color: "thirdRankColor"
                                    },
                                    fontWeight: "semibold",
                                    p: tabPadding,
                                    children: [
                                        section.period,
                                        " "
                                    ]
                                }, sid))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
                        topArrow: "25%",
                        settings: {
                            infinite: true,
                            speed: 500,
                            slidesToShow: 5,
                            slidesToScroll: 5,
                            responsive: [
                                {
                                    breakpoint: 1000,
                                    settings: {
                                        slidesToShow: 4,
                                        slidesToScroll: 4,
                                        initialSlide: 4,
                                        infinite: true
                                    }
                                },
                                {
                                    breakpoint: 680,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2,
                                        infinite: true
                                    }
                                }
                            ]
                        },
                        children: leaderboards.map((editor, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderBoardCard, {
                                index: index,
                                editor: editor
                            }, "editor-".concat(index)))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Leaderboard = (LeaderBoard);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/table/dist/index.esm.js
var table_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/table/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__("./node_modules/react-icons/bi/index.esm.js");
// EXTERNAL MODULE: ./src/components/Rank/RankButton.tsx
var RankButton = __webpack_require__("./src/components/Rank/RankButton.tsx");
// EXTERNAL MODULE: ./src/components/Rank/RankTable.tsx + 3 modules
var RankTable = __webpack_require__("./src/components/Rank/RankTable.tsx");
// EXTERNAL MODULE: ./src/components/Rank/InvalidRankCardItem.tsx
var InvalidRankCardItem = __webpack_require__("./src/components/Rank/InvalidRankCardItem.tsx");
// EXTERNAL MODULE: ./src/components/Rank/RankCardItem.tsx + 1 modules
var RankCardItem = __webpack_require__("./src/components/Rank/RankCardItem.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/RankingList.tsx











const RankingList = (param)=>{
    let { rankings  } = param;
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        mt: 10,
        px: {
            base: 3,
            md: 8
        },
        pb: {
            base: 5,
            md: 20
        },
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                textAlign: "center",
                mb: 4,
                fontWeight: "700",
                fontSize: {
                    base: "3xl",
                    lg: 46
                },
                children: "".concat(t("rankingListHeading"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                color: "homeDescriptionColor",
                fontSize: {
                    base: "lg",
                    lg: 22
                },
                mx: "auto",
                mb: 9,
                px: 4,
                maxW: "800",
                children: "".concat(t("rankingListDescription"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                maxW: "1208px",
                mx: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* Tabs */.mQ, {
                        mt: 10,
                        defaultIndex: 0,
                        p: "0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* TabList */.td, {
                                    border: "none",
                                    display: "flex",
                                    gap: {
                                        base: "5",
                                        md: "8"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RankButton/* default */.Z, {
                                            label: "Cryptocurrencies",
                                            icon: ri_index_esm/* RiCoinsFill */.SSK,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RankButton/* default */.Z, {
                                            label: "NFTs",
                                            icon: bi_index_esm/* BiImage */.ntj,
                                            fontSize: {
                                                lg: "md"
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* TabPanels */.nP, {
                                mt: {
                                    base: 8,
                                    md: "10"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanel */.x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankTable/* RankTable */.v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RankTable/* RankTableHead */._, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Tbody */.p3, {
                                                    children: rankings.TokensListing.map((token, index)=>token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankCardItem/* default */.Z, {
                                                            index: index,
                                                            item: token
                                                        }, index + token.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InvalidRankCardItem/* InvalidRankCardItem */.D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanel */.x4, {
                                        px: {
                                            base: 2,
                                            md: "initial"
                                        },
                                        py: {
                                            base: 0,
                                            md: "initial"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankTable/* RankTable */.v, {
                                            hasPagination: false,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RankTable/* RankTableHead */._, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table_dist_index_esm/* Tbody */.p3, {
                                                    children: rankings.NFTsListing.map((nft, index)=>nft ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankCardItem/* default */.Z, {
                                                            index: index,
                                                            item: nft
                                                        }, index + nft.id) : /*#__PURE__*/ (0,jsx_runtime.jsx)(InvalidRankCardItem/* InvalidRankCardItem */.D, {
                                                            index: index
                                                        }, index))
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                        justifyContent: "center",
                        mt: "10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                            href: "/rank",
                            h: "50px",
                            w: {
                                base: 32,
                                lg: 40
                            },
                            variant: "outline",
                            bgColor: "btnBgColor",
                            prefetch: false,
                            children: "View More"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Landing_RankingList = (RankingList);

;// CONCATENATED MODULE: ./src/components/Landing/Hero.tsx



const Hero = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Heading */.X6, {
                w: "full",
                textAlign: "center",
                px: {
                    base: "5",
                    md: "0"
                },
                fontSize: {
                    base: "35",
                    md: "40"
                },
                children: [
                    "The World's Largest",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(system_dist_index_esm/* chakra.span */.m$.span, {
                        color: "brandLinkColor",
                        children: " Blockchain & Crypto "
                    }),
                    "Encyclopedia"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                px: {
                    base: "5",
                    md: "0"
                },
                textAlign: "center",
                mt: "5",
                fontSize: {
                    base: "md",
                    lg: "2xl"
                },
                children: "Start your crypto journey with IQ Wiki! The compass for exploring your web3 curiosities."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx









var __N_SSG = true;
const Index = (param)=>{
    let { promotedWikis , recentWikis , popularTags , leaderboards , rankings , trending  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
        direction: "column",
        mx: "auto",
        w: "full",
        pt: {
            base: 6,
            lg: 12
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                _dark: {
                    bgImage: "/images/backgrounds/homepage-bg-dark.png"
                },
                bgImage: "/images/backgrounds/homepage-bg-white.png",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_TrendingWikis, {
                        trending: trending,
                        recent: recentWikis === null || recentWikis === void 0 ? void 0 : recentWikis.slice(0, 5),
                        featuredWikis: promotedWikis && promotedWikis
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_RankingList, {
                        rankings: rankings
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_CategoriesList, {})
                ]
            }),
            leaderboards.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Leaderboard, {
                leaderboards: leaderboards
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Landing_DiscoverMore, {
                tagsData: popularTags
            })
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js");

const getReadableDate = (dateToFormat)=>{
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(dateToFormat), {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiSummary.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ WikiSummarySize; },
/* harmony export */   "L": function() { return /* binding */ getWikiSummary; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

var WikiSummarySize;
(function(WikiSummarySize) {
    WikiSummarySize[WikiSummarySize["Small"] = 65] = "Small";
    WikiSummarySize[WikiSummarySize["Medium"] = 70] = "Medium";
    WikiSummarySize[WikiSummarySize["BIG"] = 110] = "BIG";
    WikiSummarySize[WikiSummarySize["Huge"] = 160] = "Huge";
})(WikiSummarySize || (WikiSummarySize = {}));
const getWikiSummary = function(wiki) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WikiSummarySize.Huge;
    if (wiki.summary) return (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenText */ .El)(wiki.summary, size);
    return "";
};


/***/ }),

/***/ "./src/utils/textUtils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ slugifyText; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "TY": function() { return /* binding */ lettersToNum; },
/* harmony export */   "Zw": function() { return /* binding */ isVerifiedContentLinks; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lK": function() { return /* binding */ shortenBalance; },
/* harmony export */   "p0": function() { return /* binding */ shortenAccount; }
/* harmony export */ });
/* unused harmony export shortenMediaText */
/* harmony import */ var _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/slugify/slugify.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_2__);



const lettersToNum = (str)=>{
    let out = 0;
    const len = str.length;
    for(let pos = 0; pos < len; pos += 1){
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1);
    }
    return out;
};
const shortenAccount = function(account) {
    let firstTakeLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, secondTakeLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    const firstChunk = account.substring(0, firstTakeLength);
    const secondChunk = account.substring(account.length - secondTakeLength);
    return "".concat(firstChunk, "...").concat(secondChunk);
};
const shortenBalance = (balance)=>typeof balance === "number" ? humanize_plus__WEBPACK_IMPORTED_MODULE_2__.formatNumber(balance, 2) : balance;
const shortenText = (text, length)=>{
    return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text.substring(0, length), "...") : text;
};
const shortenMediaText = (name)=>{
    const nameArray = name.split(".");
    return nameArray[0].length > 6 ? "".concat(nameArray[0].substring(0, 6), "....").concat(nameArray[1]) : name;
};
const slugifyText = (text)=>{
    return slugify__WEBPACK_IMPORTED_MODULE_1___default()(text.toLowerCase(), {
        strict: true,
        lower: true,
        remove: /[*+~.()'"!:@]/g
    });
};
const isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (_e) {
        return false;
    }
};
const isVerifiedContentLinks = (content)=>{
    const markdownLinks = content.match(/\[(.*?)\]\((.*?)\)/g);
    let isValid = true;
    markdownLinks === null || markdownLinks === void 0 ? void 0 : markdownLinks.every((link)=>{
        const linkMatch = link.match(/\[(.*?)\]\((.*?)\)/);
        const text = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[1];
        const url = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[2];
        if (text && url && _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedLinkNames.includes */ .Kp.includes(text) && !isValidUrl(url)) {
            isValid = true;
            return true;
        }
        if (url && url.charAt(0) !== "#") {
            const validURLRecognizer = new RegExp("^https?://(www\\.)?(".concat(_everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedDomains.join */ .xw.join("|"), ")"));
            isValid = validURLRecognizer.test(url);
            return isValid;
        }
        return true;
    });
    return isValid;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,1228,4617,3874,5675,2192,7249,8764,5619,4095,6788,6422,4116,892,8283,467,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Findex.tsx&page=%2F!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);